// Types and interfaces for Databricks configuration
// Extracted from legacy DatabricksCredentialsForm component

export enum SparkConfigurationMapKey {
  GLUE_CATALOG_ID = 'spark.hadoop.hive.metastore.glue.catalogid',
  GLUE_CATALOG_ID_ENABLED = 'spark.databricks.hive.metastore.glueCatalog.enabled',
}

export enum FieldMaskValues {
  workspace_url = 'databricksConfig.workspaceUrl',
  api_token = 'databricksConfig.apiToken.value',
  instance_profile = 'userSparkSettings.instanceProfileArn',
  spark_conf = 'userSparkSettings.sparkConf',
}

export interface DatabricksConfigInterface {
  workspace_url?: string;
  api_token?: { value: string };
  instance_profile_arn?: string;
  glueCatalogEnabled?: boolean;
  glueCatalogId?: string;
}

export interface UpdateUserDeploymentSettingsRequestInterface {
  user_deployment_settings: {
    databricks_config?: {
      workspace_url?: string;
      api_token?: { value: string };
    };
    user_spark_settings?: {
      instance_profile_arn?: string;
      spark_conf?: { [key: string]: string };
    };
  };
  field_mask: string;
}

export interface SubmissionInterface {
  databricksUrl: string;
  databricksApiToken: string;
  instanceProfileArn: string;
  glueCatalogEnabled: boolean;
  glueCatalogId: string;
}
